import { money, STATUS, fmtDay, fmtTime, fmtLongDate, bookingWaMessage } from "@/lib/booking";
import { waLinkFrom } from "@/lib/siteData";
import { panel } from "./ui";

export function BookingConfirmation({ data, tour, settings, customer }) {
    const when = data.starts_at ? `${fmtLongDate(data.starts_at)} às ${fmtTime(data.starts_at)}` : `${fmtDay(data.day)} (data a combinar)`;
    const whatsappMessage = bookingWaMessage({ tour, when, adults: Number(data.adults || data.guests || 1), kids: Number(data.children_paid || 0) + Number(data.children_free || 0), quote: data, code: data.code, name: customer.name });
    const rows = [
        ["Código", data.code, "confirmation-code"],
        ["Cliente", customer.name],
        ["Experiência", tour.title],
        ["Data e horário", when],
        ["Pessoas", data.guests],
        ["Valor total", money(data.total), "confirmation-total"],
        ["Status", STATUS[data.status] || data.status, "confirmation-status"],
        ["Valor pendente", money(data.balance)],
        ["Local de embarque", tour.meeting_point || "Informado pela equipe na confirmação"],
    ];
    return (
        <div className={panel + " mt-8 space-y-5"} data-testid="booking-request-sent">
            <h2 className="font-display text-2xl font-bold text-neon-cyan">Solicitação recebida</h2>
            <dl className="grid gap-3 sm:grid-cols-2">
                {rows.map(([k, v, id]) => (
                    <div key={k}><dt className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-dim">{k}</dt>
                        <dd className="mt-1 font-semibold" data-testid={id}>{v}</dd></div>
                ))}
            </dl>
            <a href={waLinkFrom(settings, whatsappMessage)} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-12 items-center justify-center rounded-full border border-neon-wa/60 bg-neon-wa/10 px-6 py-3 text-sm font-bold text-neon-wa" data-testid="confirmation-whatsapp">Enviar detalhes ao atendimento pelo WhatsApp</a>
            {data.hold_expires_at && <p className="text-sm text-neon-sun">Vaga reservada temporariamente até {fmtTime(data.hold_expires_at)}. Sem pagamento confirmado, ela será liberada.</p>}
            <p className="text-sm leading-relaxed text-dim">
                Esta ainda não é uma reserva confirmada. A equipe verificará disponibilidade e condições de segurança e de clima. Nenhum pagamento foi cobrado.
                {tour.safety_info ? ` ${tour.safety_info}` : " Chegue com 20 minutos de antecedência e leve documento com foto."}
            </p>

        </div>
    );
}
